import { ExternalLink } from "lucide-react";
import type { ReactNode } from "react";

interface ExternalReferenceProps {
  href: string;
  children: ReactNode;
}

export function ExternalReference({
  href,
  children
}: ExternalReferenceProps) {
  return (
    <a href={href} rel="noreferrer" target="_blank">
      <span>{children}</span>
      <ExternalLink aria-hidden="true" size={15} />
    </a>
  );
}
